import { Input } from "@heroui/react"
import { useState } from "react"
import { isEmailValid } from "../validate"
import { useMediaQuery } from '@custom-react-hooks/use-media-query';

export const EmailInput = ({ email, setEmail }) => {

    const isDesktop = useMediaQuery(process.env.REACT_APP_IS_DESKTOP);
    const [errorMessage, setErrorMessage] = useState("")

    const handleOnValueChange = (value) => {
        const sanitizedValue = value.replace(/\s/g, "");
        setEmail(sanitizedValue)

        if (!sanitizedValue) {
            setErrorMessage("メールアドレスを入力してください。"); // Email is required.
        } else if (!isEmailValid(sanitizedValue)) {
            setErrorMessage("有効なメールアドレスを入力してください。"); // Please enter a valid email.
        } else {
            setErrorMessage("");
        }
    }

    const handleFocus = (e) => {
        // We use a small timeout to let the mobile keyboard 
        // begin its slide-up animation first.
        setTimeout(() => {
            e.target.scrollIntoView({
                behavior: "smooth",
                block: "center", // Positions the input in the middle of the visible area
            });
        }, 300);
    };

    return (
        <Input
            errorMessage={errorMessage}
            isInvalid={errorMessage !== ""}
            value={email}
            onValueChange={handleOnValueChange}
            label="メール"
            type="email"
            size={isDesktop ? "md" : "lg"}
            classNames={{
                input: `${"group-data-[has-value=true]:text-base-text"}`,
                inputWrapper: ["!rounded-2xl bg-base-input/40 backdrop-blur data-[hover=true]:bg-base-input/80 group-data-[focus=true]:bg-base-input/80 shadow-none", 
                    'rounded-xl', `border border-white/0 ${errorMessage !== "" && "border-red-500"}`],
                label: `text-base-text/60 font-light`,
                errorMessage: "!text-[#98383A]"
            }}
        // onFocus={handleFocus}
        />
    )
}